var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    stroke: "#444",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.363 39.509L21.356 5.6a2.983 2.983 0 015.288 0l17.993 33.909A3.046 3.046 0 0141.993 44H6.007a3.046 3.046 0 01-2.644-4.491z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M24 16v14"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    cx: 24,
    cy: 36,
    r: 1
  }))));
}

export default SvgWarningSign;